angular
    .module('control.searchDropdown')
    .directive("searchClaimDropdown", ['$rootScope', '$filter', 'claimSumm', 'commonConst', '$timeout', 'searchDropdownConst',
        function ($rootScope, $filter, claimSumm, commonConst, $timeout, searchDropdownConst) {
            return {
                restrict: 'E',
                require: ['ngModel'],
                templateUrl: 'module/control/searchDropdown/search-claim-dropdown.html',
                scope: {
                    rowsPerPage: '=',
                    params: '=',
                    ngRequired: '=',
                    manualSelect: '=',
                    ngModel: '=',
                    selectedData: '=',
                    placeholder: '@',
                    requiredEmptyClaimMessage: '='
                },
                controller: function ($scope) {
                    if (angular.isUndefined($scope.placeholder)) {
                        $scope.placeholder = searchDropdownConst.CLAIM_DROPDOWN_PLACEHOLDER;
                    }
                    if (angular.isUndefined($scope.params)) {
                        $scope.params = {};
                    }
                    if (angular.isUndefined($scope.rowsPerPage)) {
                        $scope.rowsPerPage = commonConst.ROWS_PER_PAGE;
                    }
                    $scope.emptyClaimMessage = 'No claim(s) attached to your account';
                    if(angular.isUndefined($scope.requiredEmptyClaimMessage)) {
                        $scope.requiredEmptyClaimMessage = $scope.emptyClaimMessage;
                    }
                    $scope.ngRequired = $filter('boolConverter')($scope.ngRequired);
                    $scope.manualSelect = !$scope.ngRequired;
                    $scope.isClaimant = $rootScope.user.IsClaimant;

                    (function onInit() {
                        claimSumm.getClaimListByIdentifier(1, $scope.rowsPerPage, '', 1, $scope.params.jurisdiction).then(function (response) {
                            $scope.claimCount = response.ClaimCount;

                            var jurisdiction = $rootScope.getSelectedJurisdiction();
                            if($scope.params.jurisdiction !== undefined && $scope.params.jurisdiction !== null) {
                                jurisdiction = $scope.params.jurisdiction;
                            }

                            var recentlySelectedType = $filter('decstr64')(sessionStorage.RecentlySelectedType);
                            var claim = $filter('dec2obj')(sessionStorage.Claim);

                            // set model to null if selected policy not belong to current dropdown jurisdiction
                            if(claim && jurisdiction && claim.Scheme !== jurisdiction) {
                                $scope.ngModel = null;
                            }

                            $scope.claimList = response.ClaimList.Data.map(function (it) {
                                return new ClaimModel(it, $scope.isClaimant, $filter);
                            });

                            if ($scope.claimCount > 0 && $scope.claimCount <= 10) {
                                if ($scope.claimCount === 1) {
                                    // move here because after request, data type change from boolean to string
                                    $scope.manualSelect = $filter('boolConverter')($scope.manualSelect);
                                    // if we have only 1 claim and want to show additional option 'Select a claim'
                                    if ($scope.manualSelect && recentlySelectedType !== commonConst.CLAIM) {
                                        $("#claim-id").val('null').trigger("change");
                                        $scope.setSelectedData();

                                    } else { // if we want show label so as to indicate that unique claim is selected
                                        $("#claim-id").val($scope.claimList[0].ClaimId).trigger("change");
                                        $scope.setSelectedData($scope.claimList[0], null, true);
                                    }

                                } else {
                                    var claimIndex = $scope.claimList.findIndex(function (it) {
                                        return (!!claim) ? (it.ClaimId === claim.ClaimId) : false;
                                    });

                                    if (!!claim &&
                                        (jurisdiction == null || claim.Scheme === jurisdiction) &&
                                        recentlySelectedType == commonConst.CLAIM &&
                                        claimIndex > -1) {
                                        $scope.setSelectedData($scope.claimList[claimIndex], null, true);
                                    }
                                }

                            } else if ($scope.claimCount > 10) {
                                if (!!claim &&
                                    (jurisdiction == null || claim.Scheme === jurisdiction) &&
                                    recentlySelectedType == commonConst.CLAIM) {
                                    $scope.setSelectedData(claim, null, true);
                                }
                            }
                        });
                    })(); // onInit

                    $scope.$on('resetClaimSelection', function (event) {
                        if ($scope.claimCount >= 1) {
                            $scope.ngModel = null;
                            $scope.selectedData = null;
                            $timeout(function () {
                                // select2 accepts null as first option value, html select accepts empty
                                $("#claim-id").val($scope.claimCount > 10 ? 'null' : '').trigger("change");
                                $('#claim-id').data('kmselect2LastSearch', '');
                            });
                        }
                    }); // resetClaimSelection

                    $scope.setSelectedData = function (claim, callback, emitChange, childScope) {
                        if(!childScope) {
                            childScope = $scope;
                        }
                        if (!claim || !claim.ClaimId) {
                            childScope.ngModel = null;
                            childScope.selectedData = null;
                            $scope.selectedData = null;
                            $scope.ngModel = null;

                        } else {
                            childScope.ngModel = claim.ClaimId;
                            // claim.InjuryDate = $filter('EMdate')(claim.InjuryDate);
                            childScope.selectedData = new ClaimModel(claim, $scope.isClaimant, $filter);
                        }

                        if (!!emitChange) {
                            $scope.$emit('claimSelectionChanged', $scope.selectedData);
                        }

                        if (callback) {
                            callback([claim]);
                        }
                    }; // setSelectedData

                    $scope.fnQuery = function (childScope, key, callback) {
                        claimSumm.getClaimListByIdentifier(1, $scope.rowsPerPage, key, $scope.params.sortBy || 1, $scope.params.jurisdiction).then(function (data) {

                            var list = data.ClaimList.Data.map(function (x) {
                                // x.InjuryDate = $filter('EMdate')(x.InjuryDate);
                                return new ClaimModel(x, $scope.isClaimant, $filter);
                            });

                            if (data.ClaimList.Data.length > 0) {
                                list.unshift(new ClaimModel(null, $scope.isClaimant));
                            }

                            var result = {
                                results: list,
                                totalItems: data.ClaimCount
                            };

                            $scope.currentList = list;
                            childScope.currentList = list;
                            childScope.totalItemsFound = result.totalItems;
                            childScope.totalItemsShown = result.totalItems > $scope.rowsPerPage ? $scope.rowsPerPage : result.totalItems;
                            childScope.cacheDataSource[key] = result;
                            callback(result);
                        });
                    }; // fnQuery

                    $scope.fnCurrent = _.debounce(function (childScope, callback) {
                        if (childScope.ngModel) {
                            //only get policy info when another claim is selected
                            if (!childScope.selectedData || childScope.selectedData.id !== childScope.ngModel) {
                                // check if selected claim is in current list claim
                                var claimInfo = childScope.currentList.filter(function (c) {
                                    return c.id === childScope.ngModel;
                                })[0];

                                if (claimInfo) {
                                    $scope.selectedData = childScope.selectedData = claimInfo;
                                    // fetch data async
                                    $timeout(function () {
                                        $scope.ngModel = childScope.ngModel;
                                    });
                                    // $scope.selectedData = claimInfo;
                                    callback([claimInfo]);
                                    $scope.setSelectedData(childScope.selectedData, callback, childScope);

                                } else {
                                    claimSumm.getNationalClaimDetails(childScope.ngModel).then(function (claim) {
                                        $scope.selectedData = childScope.selectedData = new ClaimModel(claim, $scope.isClaimant, $filter);
                                        $scope.setSelectedData(childScope.selectedData, callback, childScope);
                                    });
                                }

                            } else {
                                callback([childScope.selectedData]);
                            }

                        } else {
                            var emitChange = !!childScope.selectedData;
                            $scope.setSelectedData(null, null, emitChange, childScope);
                            callback([{
                                id: 'null',
                                text: $scope.placeholder,
                                EmployerId: '',
                                EmployerName: ''
                            }]);
                        }
                    }); // fnCurrent
                }, // controller
                link: function (scope, element, attrs) {} // link
            };
        }
    ])